const contactData = {
	title: 'Contact Us',
	text:
		'Customer And Sales Support Ready to Serve'
};

export default contactData;
